import React, { useState } from 'react'
import { Hash, HelpCircle, Layers, Sliders } from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import HelpModal from '../../components/HelpModal/HelpModal'
import { useNavigate } from 'react-router-dom'

const SystemConfiguration = () => {
  const navigate = useNavigate()
  const [showHelp, setShowHelp] = useState(false)

  const breadcrumbItems = [
    { label: 'Settings', path: '/settings', onClick: () => navigate('/settings') },
    { label: 'System', path: '/settings/system', isCurrent: true },
  ]

  const cards = [
    {
      key: 'dropdown',
      title: 'Dropdown',
      description: 'Shared dropdown lists and lookup values used across modules',
      icon: Layers,
      path: '/settings/dropdown-master',
    },
    {
      key: 'auto-increment',
      title: 'Auto Increment',
      description: 'Document number sequences and counters',
      icon: Hash,
      path: '/settings/auto-increment-master',
    },
    {
      key: 'app-parameters',
      title: 'App Parameters',
      description: 'Application-level parameters such as FX rates and feature toggles',
      icon: Sliders,
      path: '/settings/application-parameters',
    },
  ]

  return (
    <div className="sales-dashboard">
      <div className="breadcrumb-section">
        <Breadcrumb
          items={breadcrumbItems}
          rightSlot={
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
              onClick={() => setShowHelp(true)}
              title="Help"
              aria-label="Open help"
            >
              <HelpCircle size={18} />
              <span className="d-none d-sm-inline">Help</span>
            </button>
          }
        />
      </div>

      <div className="page-header">
        <div className="page-title">
          <h1>System</h1>
          <p>Lookups, sequences and application parameters</p>
        </div>
      </div>

      <div className="settings-masters-grid">
        {cards.map((card) => {
          const Icon = card.icon
          return (
            <div
              key={card.key}
              className="settings-master-card"
              onClick={() => navigate(card.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  navigate(card.path)
                }
              }}
            >
              <div className="settings-master-icon">
                <Icon size={24} />
              </div>
              <div className="settings-master-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          )
        })}
      </div>

      <HelpModal isOpen={showHelp} onClose={() => setShowHelp(false)} title="System – Help">
        <h3>System configuration</h3>
        <p>Configure <strong>Dropdown</strong> lists, <strong>Auto Increment</strong> sequences, and <strong>App Parameters</strong> used across the ERP.</p>
      </HelpModal>
    </div>
  )
}

export default SystemConfiguration
